import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import auth from "../../services/authService";

const Help = (props) => {
  const { helpShowHide, handleHelpShowHide, module, helpDocs } = props;
  const [viewerSrc, setViewerSrc] = useState("");

  const helpDocUrl = useMemo(() => {
    if (!helpDocs) return "";
    if (typeof helpDocs === "string") return helpDocs;
    return helpDocs.uploadUrl || "";
  }, [helpDocs]);

  useEffect(() => {
    if (!helpDocUrl || !helpShowHide) {
      setViewerSrc("");
      return undefined;
    }

    let objectUrl = "";
    let isCancelled = false;

    const loadPdf = async () => {
      try {
        const response = await fetch(helpDocUrl);
        if (!response.ok) throw new Error("Unable to load help document.");

        const blob = await response.blob();
        objectUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
        if (!isCancelled) {
          setViewerSrc(`${objectUrl}#toolbar=0&navpanes=0&scrollbar=0`);
        }
      } catch (error) {
        if (!isCancelled) {
          setViewerSrc(`${helpDocUrl}#toolbar=0&navpanes=0&scrollbar=0`);
        }
      }
    };

    loadPdf();

    return () => {
      isCancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [helpDocUrl, helpShowHide]);

  const user = auth.getCurrentUser();
  const headerIconClass = module === "Support" ? "fa-comments" : "fa-info-circle";

  return (
    <React.Fragment>
      <Modal
        show={helpShowHide}
        onHide={handleHelpShowHide}
        dialogClassName="rt-profile-modal theme-primary"
        centered
        backdrop="static"
      >
        <style>{`
          .modal-backdrop {
            z-index: 1080 !important;
          }
          .modal {
            z-index: 1090 !important;
          }
          .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
          }
          .modal.fade .rt-profile-modal.modal-dialog {
            transform: scale(0.95) !important;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
          }
          .modal.show .rt-profile-modal.modal-dialog {
            transform: scale(1) !important;
          }
          .rt-profile-modal {
            --task-accent: #2563eb;
            --task-soft: #eff6ff;
            width: min(1100px, calc(100vw - 64px)) !important;
            max-width: min(1100px, calc(100vw - 64px)) !important;
            height: auto !important;
          }
          .rt-profile-modal .modal-content {
            border-radius: 12px !important;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
            overflow: hidden !important;
            background: #ffffff !important;
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            max-height: calc(100vh - 60px) !important;
            display: flex !important;
            flex-direction: column !important;
          }
          .rt-profile-modal .modal-header {
            position: relative !important;
            display: block !important;
            padding: 24px 28px 20px 32px !important;
            background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
            border-bottom: 1px solid #edf2f7 !important;
            overflow: hidden !important;
          }
          .rt-profile-modal .modal-header::before {
            content: "" !important;
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            bottom: 0 !important;
            width: 4px !important;
            background: var(--task-accent) !important;
          }
          .rt-profile-modal .rt-header-shell {
            display: flex !important;
            flex-direction: column !important;
            gap: 14px !important;
            width: 100% !important;
          }
          .rt-profile-modal .rt-header-top {
            display: flex !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            gap: 18px !important;
            width: 100% !important;
          }
          .rt-profile-modal .rt-header-main {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
            flex: 1 1 auto !important;
          }
          .rt-profile-modal .rt-header-copy {
            display: flex !important;
            flex-direction: column !important;
            gap: 8px !important;
            min-width: 0 !important;
            padding-top: 4px !important;
          }
          .rt-profile-modal .rt-header-icon {
            width: 52px !important;
            height: 52px !important;
            min-height: 52px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: var(--task-accent) !important;
            background: #ffffff !important;
            border: 1px solid var(--task-accent) !important;
            box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
            font-size: 18px !important;
            flex-shrink: 0 !important;
          }
          .rt-profile-modal .rt-modal-title {
            display: inline-flex !important;
            align-items: center !important;
            margin: 0 !important;
            color: #0f172a !important;
            font-size: 18px !important;
            font-weight: 850 !important;
            line-height: 1.2 !important;
            min-width: 0 !important;
          }
          .rt-profile-modal .rt-modal-title-text {
            display: inline-flex !important;
            align-items: center !important;
            gap: 12px !important;
            min-width: 0 !important;
            flex-wrap: wrap !important;
          }
          .rt-profile-modal .rt-modal-title-badge {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 4px 10px !important;
            border-radius: 999px !important;
            font-size: 10px !important;
            font-weight: 800 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.02em !important;
            background: var(--task-soft) !important;
            color: var(--task-accent) !important;
            border: 1px solid #e2e8f0 !important;
          }
          .rt-profile-modal .rt-modal-meta-row {
            display: flex !important;
            align-items: center !important;
            flex-wrap: wrap !important;
            gap: 10px 12px !important;
            margin-top: 0 !important;
            padding-left: 0 !important;
            font-size: 12px !important;
            color: #64748b !important;
          }
          .rt-profile-modal .rt-meta-chip {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            background: #ffffff !important;
            padding: 5px 10px !important;
            border-radius: 8px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            border: 1px solid #e2e8f0 !important;
            box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
          }
          .rt-profile-modal .rt-meta-chip i {
            color: var(--task-accent) !important;
            font-size: 11px !important;
          }
          .rt-profile-modal .rt-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 40px !important;
            height: 40px !important;
            padding: 0 !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            color: #64748b !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
          }
          .rt-profile-modal .rt-action-btn:hover {
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            background: #f8fafc !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-profile-modal .rt-action-btn i {
            font-size: 11px !important;
            color: #94a3b8 !important;
            transition: color 0.2s ease !important;
          }
          .rt-profile-modal .rt-action-btn:hover i {
            color: #ef4444 !important;
          }
          .rt-profile-modal .modal-body {
            padding: 24px 28px !important;
            background: #ffffff !important;
            max-height: calc(100vh - 220px) !important;
            min-height: 0 !important;
            overflow-y: auto !important;
          }
          .rt-profile-modal .modal-footer {
            background: #f8fafc !important;
            border-top: 1px solid #edf2f7 !important;
            padding: 16px 24px !important;
            display: flex !important;
            justify-content: flex-end !important;
            gap: 12px !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px !important;
            padding: 9px 20px !important;
            font-size: 13px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn i {
            font-size: 11px !important;
            color: #94a3b8 !important;
          }
          .rt-profile-modal .wf-modal-footer-close-btn:hover i {
            color: #ef4444 !important;
          }
          .rt-support-welcome-card {
            background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%) !important;
            border: 1px solid #e2e8f0 !important;
            border-radius: 12px !important;
            padding: 24px !important;
            box-shadow: 0 1px 3px rgba(15, 23, 42, 0.03) !important;
            margin-bottom: 16px !important;
          }
          .rt-support-welcome-card h3 {
            margin: 0 0 16px 0 !important;
            font-size: 16px !important;
            font-weight: 800 !important;
            color: #0f172a !important;
          }
          .rt-support-welcome-card p {
            font-size: 13.5px !important;
            color: #475569 !important;
            line-height: 1.6 !important;
            margin-bottom: 14px !important;
          }
          .rt-support-welcome-card p:last-of-type {
            margin-bottom: 24px !important;
          }
          .rt-support-welcome-card .support-signature h3 {
            margin: 0 !important;
            font-size: 13.5px !important;
            font-weight: 800 !important;
            color: var(--task-accent) !important;
            line-height: 1.4 !important;
          }
          .rt-support-welcome-card .support-signature h3:first-of-type {
            color: #0f172a !important;
            margin-bottom: 4px !important;
          }
        `}</style>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className={`rt-header-icon fa ${headerIconClass}`} aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>{module === "Support" ? "Add Issue" : "Help Document"}</span>
                      <span className="rt-modal-title-badge">
                        {module === "Support" ? "Support" : "Help"}
                      </span>
                    </span>
                  </h2>
                  <div className="rt-modal-meta-row">
                    <span className="rt-meta-chip">
                      <i className="fa fa-folder-open" aria-hidden="true" /> Module: {module || "General"}
                    </span>
                    {user?.name && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-user" aria-hidden="true" /> {user.name}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={handleHelpShowHide}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {module === "Support" && (
            <div className="rt-support-welcome-card">
              <h3>Welcome to our Customer Support Portal!</h3>
              <p>
                In this portal we offer you an easy way to register any issue you may encounter while working and using
                various functions and features.
              </p>
              <p>
                Once you register an issue and submit, it will be received by our dedicated and committed customer and
                technical support staff who will review and provide instant fix(s), if required.
              </p>
              <p>Our customer and technical support staff will also update and notify you of the action taken.</p>
              <div className="support-signature">
                <h3>Thank you.</h3>
                <h3>WorkFINITY®</h3>
                <h3>Customer and Technical Support</h3>
              </div>
            </div>
          )}

          {helpDocUrl && (
            <div style={{ height: "650px", width: "100%", maxWidth: "1020px", margin: "auto" }}>
              {viewerSrc && (
                <iframe
                  title="Help PDF Viewer"
                  src={viewerSrc}
                  width="100%"
                  height="100%"
                  style={{ border: "none", borderRadius: "8px", boxShadow: "0 4px 12px rgba(15,23,42,0.08)" }}
                />
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={handleHelpShowHide}
          >
            <i className="fa fa-times" aria-hidden="true" />
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Help;
